<template>
  <!--
    Brand "W" mark used as the AI Chat menu icon. Rendered inline (not through
    the SVG sprite) on purpose: the gradient is a conic-gradient built with
    <foreignObject>, which does NOT render reliably when referenced via <use>.
    Inline in the DOM it renders consistently across modern browsers.
    The surrounding .showText rule sizes any child <svg> to 20x20.
  -->
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <defs>
      <clipPath id="aiChatRoundClip"><rect width="20" height="20" rx="5" /></clipPath>
    </defs>
    <foreignObject width="20" height="20" clip-path="url(#aiChatRoundClip)">
      <div
        xmlns="http://www.w3.org/1999/xhtml"
        style="width:20px;height:20px;background:conic-gradient(from 90deg,rgba(215,146,104,1) 0deg,rgba(204,123,101,1) 17.3077deg,rgba(171,108,169,1) 67.0981deg,rgba(110,81,153,1) 138.086deg,rgba(124,156,213,1) 189.898deg,rgba(130,180,200,1) 240.948deg,rgba(236,191,110,1) 326.146deg,rgba(215,146,104,1) 360deg);"
      ></div>
    </foreignObject>
    <path d="M10.0083 6.50978C10.5104 6.50354 10.9943 6.78394 11.2241 7.26712L13.6775 12.4275C13.9922 13.0894 13.7107 13.8811 13.0489 14.1957C12.387 14.5104 11.5953 14.229 11.2807 13.5671L10.0083 10.8909L8.73601 13.5671C8.42133 14.229 7.62967 14.5104 6.96781 14.1957C6.30595 13.8811 6.02448 13.0894 6.33916 12.4275L8.7927 7.26712C9.02242 6.78397 9.50627 6.50357 10.0083 6.50978Z" fill="white"/>
    <path d="M6.85644 8.41275C6.17434 6.93522 4.60138 6.08261 2.99106 6.31756L6.31128 13.556C6.61646 14.2213 7.40319 14.5132 8.06851 14.2081C8.73497 13.9024 9.02657 13.1136 8.71925 12.4479L6.85644 8.41275Z" fill="white"/>
    <path d="M13.1436 8.44109C13.8256 6.96356 15.3986 6.11095 17.0089 6.3459L13.6887 13.5843C13.3835 14.2496 12.5968 14.5416 11.9315 14.2364C11.265 13.9307 10.9734 13.1419 11.2807 12.4762L13.1436 8.44109Z" fill="white"/>
  </svg>
</template>

<script>
export default {
  name: "AiChatIcon",
};
</script>
